import {Component, input, signal} from '@angular/core';
import {ButtonModule} from "primeng/button";
import {SubmitFunction} from "../custom-form/custom-form.component";
import {finalize, of, switchMap} from "rxjs";
import {definePreset} from "@primeuix/themes";
import {MyPreset} from "../../theme";
import {ActivatedRoute} from "@angular/router";
import {JsonPipe} from "@angular/common";

@Component({
  selector: 'homey-form-buttons',
  standalone: true,
  imports: [
    ButtonModule,
    JsonPipe
  ],
  templateUrl: './form-buttons.component.html',
  styleUrl: './form-buttons.component.scss',
  host: {
    class: 'flex',
    '[class.gap-4]': '!small()',
    '[class.justify-between]': 'small()',
    '[class.justify-around]': 'around()',
    '[class.flex-row]': 'small()',
    '[class.flex-col]': '!small()',
  }
})
export class FormButtonsComponent<T> {
  busyValue = signal<T | undefined>(undefined);
  small = input<boolean>(false);
  around = input<boolean>(false);
  buttons = input.required<readonly { label: string, value: T, severity?: 'primary' | 'secondary', disabled?: boolean }[]>()
  submitFunction = input.required<SubmitFunction<T>>()

  constructor(private readonly route: ActivatedRoute) {
  }

  onSelect(value: T) {
    if (this.busyValue() !== undefined) {
      return;
    }

    this.busyValue.set(value);
    of(undefined).pipe(
      switchMap(() => this.submitFunction()(value, this.route)),
      finalize(() => this.busyValue.set(undefined))
    ).subscribe()
  }
}
